import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var CheckDouble = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M2.394 13.742l4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084l-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z", key: "k0" })));
});
CheckDouble.displayName = 'CheckDouble';
export var CheckDoubleDimensions = { height: 24, width: 24 };
